import { createElement } from 'react'
import { supify } from '../utils'

import { CompareCredit } from '../../types/compare-credit'

export const getAdvertorialAttributeByCard = ({
  card,
  attribute,
  bonusRewards,
}: {
  card: (CompareCredit.FormattedCard | CompareCredit.NonPaidCard) &
    // Added just to satisfy the type checker
    // We can fix this when we fix the types in the future
    Record<string, any>
  attribute: string
  bonusRewards: string
}) => {
  const attributeValue = card[attribute]
  const bonusReward = Array.isArray(attributeValue)
    ? attributeValue.filter(({ _key }) => _key === bonusRewards)[0]
        ?.rewardDescription
    : ''

  const attributeToRender =
    attribute === 'bonusRewards' ? bonusReward : attributeValue

  return createElement('span', {
    dangerouslySetInnerHTML: {
      __html: supify(attributeToRender),
    },
  })
}

export const getCardAttribute = getAdvertorialAttributeByCard
